import { RosterPanel } from './MemberPortalRosterPanel'
import { Badge } from '@/components/ui/badge'
import { Card } from '@/components/ui/card'
import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import type { MemberPortalOrganization } from './MemberSignIn'
import { MemberPortalOrganizationRolesPanel } from './MemberPortalOrganizationRolesPanel'
import { ProfilePanel } from './MemberPortalOrganizationProfile'
import { MemberPortalOrganizationDashboard } from './MemberPortalOrganizationDashboard'
import { organizationSection } from './portalOrganizationSections'

export function MemberPortalOrganizationPage({
  organization,
  organizations = [],
  onOrganizationChange,
}: {
  organization: MemberPortalOrganization
  organizations?: MemberPortalOrganization[]
  onOrganizationChange?: (organizationId: number) => void
}) {
  return (
    <div className="space-y-4">
      {organizations.length > 1 && (
        <div className="max-w-xl space-y-1">
          <Label htmlFor="organization-picker">Organization</Label>
          <Select
            value={String(organization.id)}
            onValueChange={(value) => onOrganizationChange?.(Number(value))}
          >
            <SelectTrigger id="organization-picker" aria-label="Organization">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {organizations.map((item) => (
                <SelectItem key={item.id} value={String(item.id)}>
                  {item.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      )}
      <div>
        <h1 className="text-subheading font-semibold">Organization</h1>
        <p className="mt-1 text-body-sm text-muted-foreground">{organization.name}</p>
        <p className="mt-1 flex flex-wrap items-center gap-2 text-body-sm text-muted-foreground">
          {organization.level} <Badge variant="success">{organization.status}</Badge>
          {organization.renewal_due_on ? `renews ${organization.renewal_due_on}` : null}
        </p>
      </div>
      {organizationSection(organization, 'dashboard') ? (
        <MemberPortalOrganizationDashboard organization={organization} />
      ) : (
        <Card className="overflow-hidden">
          {organizationSection(organization, 'roster') && (
            <RosterPanel organization={organization} />
          )}
          {organizationSection(organization, 'profile') && (
            <ProfilePanel organization={organization} />
          )}
          {organizationSection(organization, 'roles') && (
            <MemberPortalOrganizationRolesPanel organization={organization} />
          )}
        </Card>
      )}
    </div>
  )
}
